module.exports = __webpack_public_path__ + "img/trashline.3a29433f.svg";